<template>
  <div class="container">
    <div class="section">
      <img class="img1" src="https://s20.lgstatic.com/growth/activity/20220422/1650595181826.png">
      <img v-if="!userCouponNo" class="receive-img" @click="receiveCoupon" src="https://s21.lgstatic.com/growth/activity/20220422/1650595347769.png">
      <img v-else class="receive-img" src="https://s20.lgstatic.com/growth/activity/20220422/1650616206461.png">
    </div>
    <div class="section">
      <img class="img2" src="https://s20.lgstatic.com/growth/activity/20220422/1650608855620.png">
    </div>
    <div class="footer" @click="goOffer">
      <img class="img" src="https://s20.lgstatic.com/growth/activity/20220422/1650609051432.png">
    </div>
    <div v-if="showSuccessModal" class="success-modal">
      <div class="modal">
        <img class="img" src="https://s21.lgstatic.com/growth/activity/20220422/1650611140672.png" >
        <img class="btn" @click="showSuccessModal = false" src="https://s20.lgstatic.com/growth/activity/20220422/1650611150500.png" >
      </div>
    </div>
  </div>
</template>

<script>
import { getCouponInfo, receiveToPersonal } from '../../../service/api';
import { Toast } from 'vant';
import * as Cookies from 'js-cookie';
export default {
  name: "DayLiveH5",
  data() {
    return {
      page_id: "p1tpe",
      showSuccessModal: false,
      cardInfo: {},
      userCouponNo: ''
    };
  },
  mounted() {
    this.eduPlatTrack('WebView', {
      page_id: this.page_id
    });
    if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token') || this.isApp) {
      this.getCouponInfo();
    }
  },
  methods: {
    // 获取优惠券信息
    getCouponInfo() {
      getCouponInfo({
        couponId: "1FFA41BC1EBE4DA6D604D5FB9FDDFED8"
      }).then(res => {
        if (res.state == 1) {
          let data = res.content;
          this.cardInfo = data;
          // 已领取状态下会有userCouponNo
          this.userCouponNo = data.userCouponNo ? data.userCouponNo : this.userCouponNo;
        } else {
          Toast(res.message);
        }
      });
    },
    receiveCoupon() {
      if (!this.isApp && !Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
        return window.open('/frontLogin.do', '_self');
      }
      this.eduPlatTrack('WebButtonClick', {
        page_id: this.page_id,
        'button_name': "立即领取"
      });
      // 判断卡片状态领取
      receiveToPersonal({
        couponId: String(this.cardInfo.encryptCouponId)
      }).then(res => {
        if (res.state == 1) {
          this.showSuccessModal = true;
          this.getCouponInfo();
        } else {
          Toast(res.message);
        }
      });
    },
    goOffer() {
      this.eduPlatTrack('WebButtonClick', {
        page_id: this.page_id,
        'button_name': "点击查看"
      });
      window.location.href = "https://edu.lagou.com/growth/sem/offer.html?utm_source=lagouedu&utm_medium=VIPHD&_channel_track_key=MYIOJ2Ri";
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  padding-bottom: 140px;
}
.section {
  position: relative;
  display: flex;
  width: 100%;
  .img1 {
    width: 100%;
    height: 924px;
  }
  .img2 {
    width: 100%;
    height: 751px;
  }
  .receive-img {
    position: absolute;
    left: 50%;
    bottom: 134px;
    width: 447px;
    height: 114px;
    transform: translateX(-50%);
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 203px;
  .img {
    width: 100%;
  }
}
.success-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 640px;
    height: 420px;
    transform: translateX(-50%) translateY(-50%);
    .img {
      width: 100%;
      height: 420px;
    }
    .btn {
      position: absolute;
      left: 35px;
      bottom: 34px;
      width: 570px;
      height: 102px;
    }
  }
}
</style>
